import React from 'react'
import { Container, Button, Row, Col, Input } from 'reactstrap';
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import 'bootstrap/dist/css/bootstrap.css';
import ConfirmButton from '../Modal/ConfirmButton';

//const testData = require('./TestData.js');

class ImportCustomerRevenue extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            importData: [],
            customerRevenueData: [],
            uploadSuccess: false,
            saveSuccess: false
        };

    }

    componentDidMount = () => {
        this.props.log('ImportCustomerRevenue.js/componentDidMount');
        this.getCustomerRevenue();
    }

    getCustomerRevenue = () => {
        this.props.log('ImportCustomerRevenue.js/getCustomerRevenue');
        fetch('/api/customerRevenue/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                if (results.success){
                    this.setState({
                        customerRevenueData: results.data
                    })
                } else {
                    this.props.addToast('Unable to load customer revenue data.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleUpload = (e, schema) => {
        this.props.log('ImportCustomerRevenue.js/handleUpload (e,schema) ', e, schema);
        e.preventDefault();
        var files = e.target.files, f = files[0];
        var reader = new FileReader();
        reader.onload = (r) => {
            var result = r.target.result;
            let readedData = XLSX.read(result, { type: 'binary', cellDates: true, sheetStubs: true });
            let tabData = [];
            readedData.SheetNames.forEach(sheet => {
                const ws = readedData.Sheets[sheet];
                /* Convert array to json*/
                let data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                const numColumns = Math.max(...data.map(el => el.length));
                if (data.length === 0) return;
                let trimBlankRowPos = -1;
                data.forEach((row, index, arr) => {
                    let newArr = new Array(numColumns).fill('');
                    const x = newArr.map((el, i) => (row[i] != null) ? row[i].toString() : '');
                    arr[index] = x;
                    if (row.every(cell => cell === '') && trimBlankRowPos === -1) {
                        trimBlankRowPos = index;
                    } else if (!(row.every(cell => cell === ''))) {
                        trimBlankRowPos = -1;
                    }
                })
                if (trimBlankRowPos > -1) data.splice(trimBlankRowPos);
                tabData.push({ tab: sheet, data: data });
            })
            tabData.forEach(tab => {
                tab.data.splice(0, 1);
            })
            let data = [];
            tabData[1].data.forEach(row => {
                let dataRow = [];
                row.filter((col, colIndex) => (colIndex === 7 || colIndex === 9 || colIndex === 11 || colIndex === 13 || colIndex === 15 || colIndex === 17 ||
                    colIndex === 19 || colIndex === 21 || colIndex === 23 || colIndex === 25)).forEach((col, colIndex) => {
                        dataRow[colIndex] = col;
                    })
                data.push(dataRow);
            })
            // console.log('tabData', tabData[1].data)
            // console.log('tabData', data)
            this.setState({
                uploadSuccess: false,
                saveSuccess: false,
                importData: data,
            });
        };
        if (f instanceof Blob || typeof (f) === 'object') {
            reader.readAsBinaryString(f)
        } else {
            this.setState({
                uploadSuccess: false,
                saveSuccess: false,
                importData: [],
            })
        }

    }

    handleSave = () => {
        this.props.log('ImportCustomerRevenue.js/handleSave');
        const json_request = JSON.stringify({
            data: this.state.importData
        });
        fetch('/api/customerRevenue/', {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                results.success ?
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: true,
                        importData: []
                    }, () => {this.getCustomerRevenue(); this.props.addToast('Customer revenue data imported successfully.', 5, 'success'); }) :
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: false,
                    }, () => this.props.addToast('Unable to import customer revenue data.', 5, 'danger'))
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    handleDelete = (year, month) => {
        this.props.log('ImportCustomerRevenue.js/handleDelete');
        fetch('/api/customerRevenue/' + year + '/' + month, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getCustomerRevenue();
                    this.props.addToast('Customer revenue data deleted successfully.', 5, 'success');
                } else {
                    this.props.addToast('Unable to delete customer revenue data.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    render = () => {
        this.props.info('ImportCustomerRevenue.js/render');
        return (
            <>
                <Container>
                    {/* {this.state.uploadSuccess ?
                        <Row><Col md={12}> {(this.state.saveSuccess ?
                            <Alert color="success">Upload successful.</Alert> :
                            <Alert color="danger">Upload unsuccessful.</Alert>)}
                        </Col></Row>
                        : <></>} */}
                    <Row>
                        <Col md={6}>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Input type="file" name={"file_"} id="file" accept='.xlsx' onChange={e => this.handleUpload(e)} />
                                </Col>
                            </Row>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Button color="success" disabled={this.state.importData.length === 0} onClick={this.handleSave} title="Upload">Upload</Button>
                                </Col>
                            </Row>
                        </Col>
                        {(this.state.importData.length > 0) ?
                            <Col md={6}>
                                <Row className="p-2">
                                    <Col md={12}>
                                        {this.state.importData.length} records ready to upload
                                    </Col>
                                </Row>
                            </Col> : <></>}
                    </Row>
                    <hr />
                    <Row className="text-left">
                        <Col>Imported files / records per month:</Col>
                    </Row>
                    <Row className="text-left">
                        <Col>
                            {this.state.customerRevenueData.map((data, dataIndex) => (
                                <span key={dataIndex} className="px-3 py-5 timerLine"><strong>{data.date}</strong> <em>({data.count})</em>
                                    <ConfirmButton color="danger" className="widthButtonIcon"
                                        onClick={() => this.handleDelete(data.year, data.month)}>
                                        <FontAwesomeIcon icon={faTimes} />
                                    </ConfirmButton>
                                </span>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default ImportCustomerRevenue;